import { render, staticRenderFns } from "./PatientFamily.vue?vue&type=template&id=6080a5c5"
import script from "./PatientFamily.vue?vue&type=script&lang=js"
export * from "./PatientFamily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports